import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff, KeyRound, Lock, Shield } from 'lucide-react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{6}$/.test(code)) return toast.error('اكتب كود الاسترجاع المكوّن من 6 أرقام');
    if (password.length < 8) return toast.error('كلمة المرور يجب ألا تقل عن 8 أحرف');
    if (password !== confirmPassword) return toast.error('تأكيد كلمة المرور غير مطابق');

    setLoading(true);
    try {
      await api.post('/auth/reset-password', { code, password });
      toast.success('تم تغيير كلمة المرور بنجاح');
      navigate('/admin/login', { replace: true });
    } catch (error) {
      toast.error(error.response?.data?.message || 'تعذر تغيير كلمة المرور');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-orvix-dark relative overflow-hidden">
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-orvix-green/10 rounded-full blur-3xl" />
      <div className="glass relative z-10 w-full max-w-md p-8 mx-4">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-orvix-primary to-orvix-green rounded-2xl flex items-center justify-center mx-auto mb-4"><Shield className="w-8 h-8 text-white" /></div>
          <h1 className="text-2xl font-bold text-white mb-2">تعيين كلمة مرور جديدة</h1>
          <p className="text-gray-400 text-sm">اكتب الكود الذي وصلك على البريد ثم اختر كلمة مرور جديدة.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-gray-300 text-sm mb-2">كود الاسترجاع</label>
            <div className="relative"><KeyRound className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" /><input inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} className="w-full pr-10 pl-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white tracking-[0.5em] text-center text-xl focus:border-orvix-green focus:outline-none" placeholder="000000" required /></div>
          </div>
          <div>
            <label className="block text-gray-300 text-sm mb-2">كلمة المرور الجديدة</label>
            <div className="relative"><Lock className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" /><input type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full pr-10 pl-12 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:border-orvix-green focus:outline-none" autoComplete="new-password" required /><button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-white">{showPassword ? <EyeOff size={20} /> : <Eye size={20} />}</button></div>
          </div>
          <div><label className="block text-gray-300 text-sm mb-2">تأكيد كلمة المرور</label><input type={showPassword ? 'text' : 'password'} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:border-orvix-green focus:outline-none" autoComplete="new-password" required /></div>
          <button type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-50">{loading ? 'جاري الحفظ...' : 'حفظ كلمة المرور الجديدة'}</button>
          <Link to="/admin/forgot-password" className="block text-center text-sm text-orvix-green hover:text-white">إرسال كود جديد</Link>
          <Link to="/admin/login" className="block text-center text-sm text-gray-400 hover:text-white">العودة لتسجيل الدخول</Link>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
